import Section from "@/components/ui/section";
import React from "react";
import Image from "next/image";
export default function Partners({ data }) {
  return (
    <Section className="bg-[#F5F5F5]">
      <h2 className="text-darkBlue text-center mt-0 !leading-none">Partners</h2>
      <div className="flex flex-row lg:flex-nowrap flex-wrap items-center justify-center auto-rows-auto w-full md:gap-8 gap-2 mt-8">
        {data.map((row, key) => (
          <LogoBox key={"logoBox" + key} data={row} />
        ))}
      </div>
    </Section>
  );
}
export const LogoBox = ({ data }) => {
  const { logo, title, link } = data;
  return link ? (
    <a
      href={link}
      target="_blank"
      className="relative z-1 bg-white border-darkBlue border-[1px] shadow-lg hover:shadow-artist transition-all duration-300 ease border-darkblue border-1 rounded-xl lg:w-[25%] md:w-[47%] w-[46%] md:h-40 h-32 flex items-center justify-center"
    >
      <Image
        src={logo}
        alt={title ?? "partner icon"}
        fill
        className="w-full object-contain p-4"
        sizes="(max-width: 479px) 200px,(max-width: 768px) 768px, (max-width: 1200px) 200px,(max-width: 1920px) 200px, 200px"
      />
    </a>
  ) : (
    <div className="z-1 bg-white shadow-lg hover:shadow-2xl transition-all duration-300 ease border-darkblue border-1 rounded-xl px-8 w-full md:h-40 h-40 flex items-center justify-center">
      <Image
        src={icon}
        alt={title ?? "partner icon"}
        fill
        className="w-full object-contain p-4"
        sizes="(max-width: 479px) 200px,(max-width: 768px) 768px, (max-width: 1200px) 200px,(max-width: 1920px) 200px, 200px"
      />
    </div>
  );
};
